import React from "react"
import gql from "graphql-tag"

import Query from "../../query/Query"
import {cycleFieldsFragment} from "../../gql/fragments/schedule"
import {questionFieldsFragment} from "../../gql/fragments/question"

export const insWizard = gql`
  query InsWizard {
     insWizard @client {
       cycle {
          ...cycleFields
       }
       questions {
          ...questionFields
       }
       isEditMode
       nextURL
       prevURL
       questionGroupId
     }
  }
  ${cycleFieldsFragment}
  ${questionFieldsFragment}
`

const GetInsWizard = ({children, ...props}) => {
  return (
    <Query {...props} query={insWizard}>
      {({data: {insWizard: data}, ...apolloState}) => {
        return children({...data, ...apolloState})
      }}
    </Query>
  )
}


export default GetInsWizard
